<template>
  <v-overlay v-model="overlay" class="justify-center">
    <v-card max-width="666" width="90vw" class="mt-4 mt-md-12 pa-4">
      <v-row>
        <v-col cols="12" md="9">
          <h2 class="text-green loader-title">{{ loaderMessage }}</h2></v-col
        >
        <v-col cols="12" md="3" class="d-flex align-center">
          <v-btn color="primary" @click="clearLoader()" block>
            schliessen
          </v-btn></v-col
        >
      </v-row>
    </v-card>
  </v-overlay>
</template>

<script setup>
  import { computed } from "vue";
  import { useLoaderStore } from "@/stores/loaderStore";

  const loaderStore = useLoaderStore();

  const overlay = computed({
    get: () => !!loaderStore.load,
    set: (value) => !value && loaderStore.clearLoader(),
  });

  const loaderMessage = computed(
    () => loaderStore.message || "Ein unbekannter Fehler ist aufgetreten."
  );

  function clearLoader() {
    loaderStore.clearLoader();
  }
</script>

<style scoped src="@/assets/styles/sfc/components/modules/LoaderOverlay.css"></style>
